<div class="em-stat-card" [class.em-stat-card--accent]="accent()">
  <div class="em-stat-card__well" [class]="'em-stat-card__well--' + tone()">
    <ng-content select="[icon]"></ng-content>
  </div>
  <div class="em-stat-card__body">
    <div class="em-stat-card__value">{{ value() ?? '—' }}</div>
    <div class="em-stat-card__label">{{ label() }}</div>
  </div>
</div>
